import script from "./AdminSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSetup.vue?vue&type=script&setup=true&lang=js"

import "./AdminSetup.vue?vue&type=style&index=0&id=71bd4487&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71bd4487"]])

export default __exports__